export const getHolidayDeliveryWarning = () => {
  const now = new Date();
  const year = now.getFullYear();

  const phase1Start = new Date(year, 8, 1);
  const phase2Start = new Date(year, 9, 15);
  const phase3Start = new Date(year, 10, 30);
  const phase3End = new Date(year, 11, 25);

  if (now < phase1Start || now > phase3End) {
    return { key: "", phase: 0 };
  }

  if (now >= phase1Start && now <= phase2Start) {
    return { key: "general.holiday_shipping_warnings.phase_one", phase: 1 };
  } else if (now >= phase2Start && now <= phase3Start) {
    return { key: "general.holiday_shipping_warnings.phase_two", phase: 2 };
  } else if (now >= phase3Start && now <= phase3End) {
    return { key: "general.holiday_shipping_warnings.phase_three", phase: 3 };
  }

  return { key: "", phase: 0 };
};
